import React, { Component } from 'react';

import HeaderComponent from '../headers/HeaderComponent';
import '../auth/auth.scss'
import PhoneListComponent from "./PhoneListComponent";
import DeliveryOTPComponent from "./DeliveryOTPComponent";
import CommonHeaderComponent from "../headers/CommonHeaderComponent";
import { withRouter } from "react-router";
import { connect } from "react-redux";

class VerifyDeliveryComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      hasSentOTP: false,
      phoneNo: null,
      initialState: true
    }
  }

  sendOtpDone(phoneNo) {
    this.setState({ hasSentOTP: true, phoneNo: phoneNo, initialState: false })
  }

  backToPhoneSelect() {
    this.setState({ hasSentOTP: false, phoneNo: null, initialState: false })
  }

  hashPhoneNumber(number) {
    return (number[0] + number[1] + '******' + number[8] + number[9]);
  }

  render() {
    return (
      <div>
        {
          !this.props.location.state ?
            <div>
              <CommonHeaderComponent title={"VERIFY DELIVERY"} enableBack={true}/>
              <div className="pd-top-global fs-18 red-text center">
                Unauthorized!!!
              </div>
            </div>
            :
            <React.Fragment>
              <CommonHeaderComponent title={`${this.props.location.state.orderNumber}`} enableBack={true}/>
              <div className="order-top-header pd-top-global">
                {
                  !this.state.hasSentOTP  && !this.state.initialState ?
                    <div className={"fs-14 align-left"}>
                      Select phone number to <b>receive OTP</b>
                      <div className="light-line" />
                    </div> :
                    <div>
                      <div className="fs-24">
                        Enter Delivery OTP
                      </div>
                      <div className="fs-14 mt-1">
                        The OTP was shared with the merchant at the time of Order Placement
                      </div>
                    </div>
                }
              {!this.state.hasSentOTP && !this.state.initialState ?
                <PhoneListComponent
                  sendOtpDone={(phoneNo) => this.sendOtpDone(phoneNo)}
                /> :
                <DeliveryOTPComponent
                  backToPhoneSelect={() => this.backToPhoneSelect()}
                  phoneNumber={this.state.phoneNo}
                  hasSentOTP={this.state.hasSentOTP}
                />
              }
            </div>
          </React.Fragment>
        }
      </div>
    )
  }
}

export default withRouter(connect()(VerifyDeliveryComponent));
